// extracted by mini-css-extract-plugin
export default {"txtActive":"AdminUsuarios_txtActive__3TeWR","txtInactive":"AdminUsuarios_txtInactive__SsYs6"};